import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { ScoresOnApplicantBox } from './ScoresOnApplicantBox';
import { PAGE_TEXT } from '../../../../lang';
import { useRecomputeGrading, type DrcDrading } from '../../../../graphql';
import {
  Accordion,
  Alert,
  Loading,
  type AlertDetails,
} from '../../../../../../components';

type ScoresOnApplicantProps = {
  isViewMode?: boolean;
  onJumpToNext?: () => void;
};

export const ScoresOnApplicant: React.FunctionComponent<
  ScoresOnApplicantProps
> = (props: ScoresOnApplicantProps) => {
  const { onJumpToNext = () => {}, isViewMode = false } = props;

  const { applicationId = '' } = useParams();
  const [initialDrcDrading, setInitialDrcDrading] = useState<DrcDrading>({
    firstDegreeUniversityRanking: 0,
    firstDegreeGPAOrClassRanking: 0,
    publicationAndMerit: 0,
    departmentInput: 0,
    bonus: 0,
    total: 0,
  });
  const [openAlert, setOpenAlert] = useState(false);
  const [loading, setLoading] = useState(true);

  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'info',
  });

  const { DRC_ASSESSMENT_DETAILS } = PAGE_TEXT;
  const STEP_TEXT = DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_F;

  const recomputeGrading = useRecomputeGrading();
  const handleRefreshGrade = async (value: string): Promise<void> => {
    setLoading(true);
    try {
      const variables = {
        applicationId: value,
      };
      const drcGradingtRes = await recomputeGrading({
        variables,
      });
      setInitialDrcDrading(
        drcGradingtRes?.data?.recomputeDSRCGrading as DrcDrading,
      );
      setLoading(false);
    } catch (error: any) {
      setAlertDetails({
        alertContent: (error as Error)?.message,
        alertType: 'error',
      });
      setOpenAlert(true);
    }
  };

  useEffect(() => {
    void handleRefreshGrade(applicationId);
  }, [applicationId]);

  return (
    <ContentBox>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      {loading ? (
        <Loading />
      ) : (
        <Accordion
          className="w-full"
          defaultExpanded
          title={STEP_TEXT.TITLE}
          details={
            <ScoresOnApplicantBox
              isViewMode={isViewMode}
              onJumpToNext={onJumpToNext}
              initialValues={initialDrcDrading}
            />
          }
        />
      )}
    </ContentBox>
  );
};

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;
